import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";

const AddCompetencyDialog = ({
  open,
  competencies,
  levels,
  selectedCompetency,
  selectedLevel,
  onCompetencyChange,
  onLevelChange,
  onClose,
  onSave,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Competency</DialogTitle>

      <DialogContent>
        <Autocomplete
          options={competencies}
          getOptionLabel={(o) => o?.name || ""}
          value={selectedCompetency || null}
          isOptionEqualToValue={(option, value) => option?.competencyId === value?.competencyId}
          onChange={(e, value) => onCompetencyChange(value)}
          renderInput={(params) => <TextField {...params} label="Competency" margin="normal" />}
        />

        <Autocomplete
          options={levels}
          getOptionLabel={(o) => `${o?.levelName || ""} (${o?.value || ""})`}
          value={selectedLevel || null}
          isOptionEqualToValue={(option, value) =>
            option?.competencyLevelId === value?.competencyLevelId
          }
          onChange={(e, value) => onLevelChange(value)}
          disabled={!selectedCompetency}
          renderInput={(params) => <TextField {...params} label="Level" margin="normal" />}
        />
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" variant="outlined" onClick={onClose}>
          Cancel
        </MDButton>

        <MDButton
          color="primary"
          variant="contained"
          onClick={onSave}
          disabled={!selectedCompetency || !selectedLevel}
        >
          Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

// 3. Assign PropTypes to the component
AddCompetencyDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  competencies: PropTypes.array,
  levels: PropTypes.array,
  selectedCompetency: PropTypes.object, // Can be null/undefined initially
  selectedLevel: PropTypes.object, // Can be null/undefined initially
  onCompetencyChange: PropTypes.func.isRequired,
  onLevelChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AddCompetencyDialog;
